import * as yup from 'yup';

export const YearSchema = yup.object({
  taxYear: yup
    .number()
    .required("Name is required")
    .min(2000, "Should be minimum 2000 characters")
    .max(2299, "Should be maximum 2299 characters"),
  status: yup
    .number()
    .required("Status is required")
});
